import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {setExportValue} from '../../actions/CreatingObjectPage'

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

class ChannelManager extends Component {
    constructor(props) {
        super(props);

        this.getAllExports = this.getAllExports.bind(this);
        this.getExportsContent = this.getExportsContent.bind(this);
        this.changeSelectedAll = this.changeSelectedAll.bind(this);
    }

    getAllExports() {
        if (this.props.exports == null) {
            return [];
        }

        let type = this.props.createdObject.props.type;
        return this.props.exports.filter(e => (type === 'RENT' && e.rent) || (type === 'SELL' && e.sale) || type === 'ALL');
    }

    isAllSelected() {
        let exportOptions = this.props.createdObject.meta.export;
        if (exportOptions == null) {
            exportOptions = {};
        }

        let allExports = this.getAllExports();
        let notChecked = this.getAllExports().filter(e => !exportOptions[e.fieldName]);

        return allExports.length != 0 && notChecked.length == 0;
    }

    changeSelectedAll(state) {
        let exportOptions = this.props.createdObject.meta.export;
        if (exportOptions == null) {
            exportOptions = {};
        }

        let props = this.props;
        let id = this.props.createdObject.id;
        let allExports = this.getAllExports();
        let notChecked = this.getAllExports().filter(e => exportOptions[e.fieldName] != state).forEach(e => {
            props.setExportValue(id, e.type, e.fieldName, state);
        });
    }

    getExportsContent() {
        const i18n = this.props.i18n;
        let elements = [];

        let exportOptions = this.props.createdObject.meta.export;
        if (exportOptions == null) {
            exportOptions = {};
        }

        let props = this.props;
        let id = this.props.createdObject.id;

        elements = this.getAllExports().map(e => {
            return <tr>
                <td>
                    <label className={"checkbox square " + (exportOptions[e.fieldName] ? " active" : "")}>
                        <input type="checkbox" name="name" checked={exportOptions[e.fieldName]} onClick={ev => {
                            props.setExportValue(id, e.type, e.fieldName, !exportOptions[e.fieldName]);
                        }}/>
                    </label>
                </td>
                <td dangerouslySetInnerHTML={{__html: e.titleHtml}}>

                </td>
                <td className="hide_mobile" dangerouslySetInnerHTML={{__html: e.commissionHtml}}>
                </td>
                <td className="hide_mobile" dangerouslySetInnerHTML={{__html: e.penaltyHtml}}>
                </td>
                <td className="hide_mobile" dangerouslySetInnerHTML={{__html: e.termsHtml}}>
                </td>
                <td>
                    <div className="all_info_arrow" data-target="#mobile_row1">
                        <i className="fa fa-angle-double-down"/>
                    </div>
                </td>
            </tr>
        });

        return (
            <tbody>
            {elements}
            </tbody>
        );
    }

    render() {
        const i18n = this.props.i18n;
        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.channelManager']}
                    </h3>
                </div>

                <div className="clearfix chanel_manager_wrapper mt30">
                    <table className="clearfix chanel_manager mt35">
                        <thead>
                        <tr>
                            <th>
                                {Tooltip(i18n, 'creatingObjectPage.channelManager.hint1')}

                                <label
                                    className={"checkbox square js_check_all " + (this.isAllSelected() ? " active" : "")}>
                                    <input type="checkbox" name="name" checked={this.isAllSelected()} onClick={ev => {
                                        this.changeSelectedAll(ev.target.checked);
                                    }}/>
                                </label>
                            </th>
                            <th>
                                {Tooltip(i18n, 'creatingObjectPage.channelManager.hint2')}

                                {i18n['creatingObjectPage.channelManager.name']}
                            </th>
                            <th className="hide_mobile">
                                {Tooltip(i18n, 'creatingObjectPage.channelManager.hint3')}

                                {i18n['creatingObjectPage.channelManager.commissions']}
                            </th>
                            <th className="hide_mobile">
                                {Tooltip(i18n, 'creatingObjectPage.channelManager.hint5')}

                                {i18n['creatingObjectPage.channelManager.cancellationCharges1']}
                                <br/>
                                {i18n['creatingObjectPage.channelManager.cancellationCharges2']}
                            </th>
                            <th className="hide_mobile">
                                {Tooltip(i18n, 'creatingObjectPage.channelManager.hint6')}

                                {i18n['creatingObjectPage.channelManager.workingConditions1']}
                                <br/>
                                {i18n['creatingObjectPage.channelManager.workingConditions2']}
                            </th>
                            <th>
                                <div className="more_arrow_placeholder"/>
                            </th>
                        </tr>
                        </thead>

                        {this.getExportsContent()}
                    </table>
                </div>

                {/*                <div className="clearfix add_mark mt30">
                    <i className="fa fa-cloud-upload"/> {i18n['creatingObjectPage.channelManager.unloadSelectedObjects']}
                </div>

                <div className="note small mt15">
                    * {i18n['creatingObjectPage.channelManager.hint7']}
                </div>*/}
            </div>
        )
    }
}


function Tooltip(i18n, code) {
    return (
        <span className="info top left">
            <i className="fa fa-question-circle"/>
                <span>
                 {i18n[code]}
                </span>
        </span>
    );
}

ChannelManager.propTypes = propTypes;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    exports: state.configuration.exports,
    createdObject: state.creatingObjectPage.createdObject
});

const mapDispatchToProps = {
    setExportValue
};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelManager);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/ChannelManager.js